import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import {
  getPayBoostEligibility,
  type PayBoostEligibilityResult,
  type PayMembers,
} from "./getPayBoostEligibility";

interface UsePayBoostEligibilityParams {
  payMembers: PayMembers | undefined;
}

export function usePayBoostEligibility(
  params: UsePayBoostEligibilityParams
): PayBoostEligibilityResult {
  const { payMembers } = params;

  const payBoostConfig = useCbhFlag(CbhFeatureFlag.SHOW_PAY_BOOST_UI, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.SHOW_PAY_BOOST_UI],
  });

  return getPayBoostEligibility({
    payBoostConfig,
    payMembers,
  });
}
